module.exports = __webpack_public_path__ + "static/media/taiwushan_package.9fcd985d.webp";